class MobileMenu {
    constructor() {
        this.mobileMenuButton = document.querySelector('.header__nav-toggle--button')
        this.mobileMenu = document.querySelector('.header__nav-mobile')
        this.contactButton = document.querySelector('.header__nav-mobile .miscusi')
        this.events()
    }

    events() {
        // Menu Button Click
        this.mobileMenuButton.addEventListener('click', () => this.menuHandler())
        
        // When Contact Us Link is Clicked
        if (this.contactButton) { this.contactButton.addEventListener('click', () => this.closeMenu()) }
    }

    menuHandler() {
        // Get Menu State
        this.isButtonActive = this.mobileMenuButton.getAttribute('aria-expanded')
        this.isMenuActive = this.mobileMenu.getAttribute('aria-expanded')

        // Change Menu State Accordingly
        this.isButtonActive === 'false' && this.isMenuActive === 'false' ? this.openMenu() : this.closeMenu()
    }

    closeMenu() {
        this.mobileMenuButton.setAttribute('aria-expanded', 'false')
        this.mobileMenu.setAttribute('aria-expanded', 'false')
    }

    openMenu() {
        this.mobileMenuButton.setAttribute('aria-expanded', 'true') 
        this.mobileMenu.setAttribute('aria-expanded', 'true')
    }
}

export default MobileMenu